import { GetterTree } from "vuex";
import { IPaymentState } from "@/core/interfaces/state/paymentState.interface";
import {
  IPayment,
  IPayments,
  IPaymentMethodsByAeroglobeSector,
  ISystemBank,
} from "@/core/interfaces/state/payments.interface";
import { StoreState } from "@/store/type";

const getters: GetterTree<IPaymentState, StoreState> = {
  isFetchingPayments: (state): boolean => state.isFetchingPayments,
  isFetchingPayment: (state): boolean => state.isFetchingPayment,
  isCreatingPayment: (state): boolean => state.isCreatingPayment,
  isUpdatingBankTransfer: (state): boolean => state.isUpdatingBankTransfer,
  payments: (state): IPayments => state.payments,
  payment: (state): IPayment | null => state.payment,
  paymentsBySectors: (state): IPaymentMethodsByAeroglobeSector | null =>
    state.paymentsByMethods,
  systemBanks: (state): ISystemBank[] => state.systemBanks,
  isFetchingSystemBanks: (state): boolean => state.isFetchingSystemBanks,
};

export default getters;
